import { Observable } from 'rxjs/Observable';
import { Operator } from 'rxjs/Operator';
import { Store, Reference, Action } from './store';
import { RootModel } from './root.model';
import { ApiHttp } from './api-http.service';
import { backend } from './backend';

export class ListObservable<T extends keyof RootModel, R> extends Observable<
  R
> {
  constructor(
    private ref$: any,
    private apiHttp: ApiHttp,
    private store: Store<RootModel>,
    source: Observable<any>,
  ) {
    super();
    this.source = source;
  }

  lift<Q>(operator: Operator<R, Q>): ListObservable<T, Q> {
    const observable = new ListObservable<T, Q>(
      this.ref$,
      this.apiHttp,
      this.store,
      this,
    );
    observable.operator = operator;
    return observable;
  }

  push(body: Object): Observable<boolean> {
    return this.ref$
      .take(1)
      .switchMap((ref: Reference<T>) => {
        const { path, query } = ref;
        const post = backend[path[0]].post;
        if (post) {
          return Observable.of(post(path[1]))
            .do(data =>
              this.store.dispatch<T>({
                type: 'API_POST',
                payload: { data, ref },
              }),
            )
            .switchMap(config => this.apiHttp.post(config, body))
            .do(data =>
              this.store.dispatch<T>({
                type: 'API_POST_SUCCESS',
                payload: { data, ref },
              }),
            );
        }
      })
      .mapTo(true);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/list-observable.ts